// Multicolumn Title Formatter
// This script formats the titles in multicolumn sections to style "Care" and "Up" with script font

document.addEventListener('DOMContentLoaded', function() {
  formatMulticolumnTitles();
});

// Also run when Shopify editor updates
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    formatMulticolumnTitles();
  });
  
  document.addEventListener('shopify:section:reorder', function() {
    formatMulticolumnTitles();
  });
}

function formatMulticolumnTitles() {
  // Select all multicolumn titles
  const titles = document.querySelectorAll('.multicolumn-card__info h3');
  
  titles.forEach(title => {
    // Get the text content
    let titleText = title.textContent.trim();
    
    // Check if title contains "Care" (case insensitive)
    if (titleText.toLowerCase().includes('care')) {
      // Split the title by "Care"
      const parts = titleText.split(/care/i);
      
      if (parts.length === 2) {
        // Clear the current content
        title.innerHTML = '';
        
        // Create span for the first part (Skin, Body, Hair, etc.)
        const categorySpan = document.createElement('span');
        categorySpan.className = 'category-name';
        categorySpan.textContent = parts[0].trim();
        
        // Create span for "Care"
        const careSpan = document.createElement('span');
        careSpan.className = 'care-word';
        careSpan.textContent = 'Care';
        
        // Append both spans without space
        title.appendChild(categorySpan);
        title.appendChild(careSpan);
      }
    }
    // Check if title contains "Up" (for Make Up)
    else if (titleText.toLowerCase().includes(' up')) {
      // Split the title by "Up"
      const parts = titleText.split(/\s+up/i);
      
      if (parts.length === 2) {
        // Clear the current content
        title.innerHTML = '';
        
        // Create span for the first part (Make)
        const categorySpan = document.createElement('span');
        categorySpan.className = 'category-name';
        categorySpan.textContent = parts[0].trim();
        
        // Create span for "Up"
        const upSpan = document.createElement('span');
        upSpan.className = 'care-word'; // Use same class for consistent styling
        upSpan.textContent = 'Up';
        
        // Append both spans without space
        title.appendChild(categorySpan);
        title.appendChild(upSpan);
      }
    }
    // For titles without "Care" or "Up", just wrap in category-name span
    else if (!title.querySelector('.category-name')) {
      const categorySpan = document.createElement('span');
      categorySpan.className = 'category-name';
      categorySpan.textContent = titleText;
      title.innerHTML = '';
      title.appendChild(categorySpan);
    }
  });
}

// Export for use in other scripts if needed
window.formatMulticolumnTitles = formatMulticolumnTitles;